<div class="modal-header">
  <div>
    <h5 class="modal-title mb-1">{{title}}</h5>
    <p class="text-muted mb-0 small">{{subtitle}}</p>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body history-timeline-body">
  <div *ngIf="isLoading" class="py-4 text-center text-muted">
    <span class="spinner-border spinner-border-sm me-2"></span>Loading history...
  </div>

  <div *ngIf="!isLoading && errorMessage" class="alert alert-danger mb-0">
    {{errorMessage}}
  </div>

  <div *ngIf="!isLoading && !errorMessage && !events.length" class="py-4 text-center text-muted">
    {{emptyMessage}}
  </div>

  <div *ngIf="!isLoading && !errorMessage && events.length" class="verti-timeline">
    <div class="event-list active" *ngFor="let event of events; let idx = index">
      <div class="event-timeline-dot">
        <i class="bx bx-history"></i>
      </div>
      <div class="event-content p-3">
        <div class="d-flex justify-content-between align-items-start gap-3 flex-wrap mb-2">
          <div>
            <h6 class="mb-1">{{getStatusLabel(event)}}</h6>
            <div class="small text-muted">
              {{event?.audit?.createdAt | date:'dd MMM yyyy, hh:mm:ss a'}}
            </div>
          </div>
          <span class="badge bg-light text-dark history-step-badge">#{{events.length - idx}}</span>
        </div>

        <div class="history-meta-grid">
          <div><strong>State:</strong> {{getStateLabel(event)}}</div>
          <div><strong>By:</strong> {{getActorLabel(event)}}</div>
          <div *ngIf="mode === 'order'"><strong>Mobile Lab:</strong> {{event?.mobileLabFlag ? 'Yes' : 'No'}}</div>
          <div *ngIf="mode === 'orderItem' && event?.qcStatus"><strong>QC:</strong> {{event?.qcStatus}}</div>
          <div *ngIf="mode === 'orderItem' && event?.boStatus"><strong>BO:</strong> {{event?.boStatus}}</div>
          <div *ngIf="mode === 'orderItem' && event?.vendorStatus"><strong>Vendor:</strong> {{event?.vendorStatus}}</div>
        </div>

        <div class="history-comment-box mt-3">
          <div class="small fw-semibold mb-1">Comment</div>
          <div class="small mb-0">{{getCommentLabel(event)}}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close()">Close</button>
</div>
